<template>
    <div>
        <div class="app-main__inner">
            <TituloComponente icono-titulo="fas fa-clipboard-list" texto-titulo="Categorias"  :to-create-action="{name:'NuevaCategoria'}" to-create-text="Nueva Categoria"/>
            <div class="tab-content">
                <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="main-card mb-3 card">
                                <div class="card-body">
                                    <h5 class="card-title">Listado de categorias</h5>
                                     <DataList ref="datatable" url="/categorias" :fields="fields" :rowClick="mostrarOpciones"></DataList>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                               
        </div>
    </div>
</template>
<script>
import TituloComponente from '@/components/layouts/TituloComponente';
import axios from 'axios';
import DataList from '@/components/layouts/DataList';
import Swal from "sweetalert2";
export default {
    name: "ListarCategorias",
    components: {
        TituloComponente,
        DataList,
    },
    data(){
        return{
            categoria: [],
            fields: [
                {
                name: "codigo",
                label: "",
                type: "title",
                class: "",
                append: '-'
                },
                {
                name: "descripcion",
                label: "",
                type: "title",
                class: ""
                }
            ],
            loading:false
        }
    },
    created(){
    },
    mounted(){

    },
    methods:{
        mostrarOpciones(categoria) {
            console.log(categoria);
            Swal.fire({
                title: categoria.descripcion,
                showCancelButton: true,
                confirmButtonText: "Editar",
                cancelButtonText: "Eliminar",
                confirmButtonColor: "#f7b924",
                cancelButtonColor: "#d33",
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                this.$router.push({name:'EditarCategoria', params:{id:categoria.id}})
                } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
                ) {
                this.eliminarCategoria(categoria)
                }
            });
        },        
        eliminarCategoria(categoria) {
        Swal.fire({
            title: "¿Estás seguro?",
            text: `¿Deseas eliminar ${categoria.descripcion} de manera permanente?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
            this.loading = true;
            axios
                .delete("categorias/" + categoria.id)
                .then(res => {
                Swal.fire(
                    "Eliminado",
                    `${res.data.categoria.descripcion} se ha eliminado con éxito.`,
                    "success"
                );
                console.log(this.$refs);
                this.$refs.datatable.update();
                })
                .catch(err => console.log(err))
                .finally(() => (this.loading = false));
            }
        });
        }
    },
}
</script>
